import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 0.61, 0.36, 1];

export function Reveal({
  children,
  as = "div",
  delay = 0,
  y = 18,
  className,
  once = true,
  ...rest
}) {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y: reduce ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration: 0.8, ease: EASE, delay: reduce ? 0 : delay }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}

// Signature on-load moment: masked line-by-line reveal for the hero heading.
export function MaskedLines({ lines, className, lineClassName }) {
  const reduce = useReducedMotion();
  return (
    <span className={`block ${className || ""}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] leading-[1.14]">
          <motion.span
            className={`block ${lineClassName || ""}`}
            initial={{ y: reduce ? 0 : "115%" }}
            animate={{ y: 0 }}
            transition={{
              duration: reduce ? 0.4 : 1,
              ease: EASE,
              delay: reduce ? 0 : 0.15 + i * 0.14,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
